// Vue版本的主要JavaScript功能
// 转换自原项目的main.js

// 默认图片和文件路径配置
const _defaultIcon = "/images/null-img.png";
const _filePath = process.env.NODE_ENV === 'development' 
  ? "https://www.anovator.com/file/FileAction!loadFile.m?key=" 
  : "/file/FileAction!loadFile.m?key=";

// 图片路径处理函数
export function imgPath(img) {
  if (!img) {
    return _defaultIcon;
  }
  if ((img + "").indexOf("http") > -1) {
    return img;
  } else {
    return _filePath + img;
  }
}

// 图片懒加载功能
export function loadImg() {
  let imgs = document.querySelectorAll('img[data-src]');
  imgs.forEach((item) => {
    if (item.dataset.src === "") return;
    item.src = item.dataset.src;
    item.removeAttribute('data-src');
  });
}

// 懒加载函数
export function lazyload() {
  let viewHeight = document.body.clientHeight; // 获取可视区高度
  let imgs = document.querySelectorAll('img[data-src]');
  imgs.forEach((item) => {
    if (item.dataset.src === "") return;
    
    // 用于获得整个页面中某个元素的左，上，右和下分别相对浏览器视窗的位置
    let rect = item.getBoundingClientRect();
    if (rect.bottom >= 0 && rect.top < viewHeight) {
      item.src = item.dataset.src;
      item.removeAttribute('data-src');
    }
  });
}

// 节流函数
export function throttle(fn, delay) {
  let timer;
  let prevTime;
  return function (...args) {
    const currTime = Date.now();
    const context = this;
    if (!prevTime) prevTime = new Date().getTime();
    clearTimeout(timer);

    if (currTime - prevTime > delay) {
      prevTime = currTime;
      fn.apply(context, args);
      clearTimeout(timer);
      return;
    }

    timer = setTimeout(function () {
      prevTime = Date.now();
      timer = null;
      fn.apply(context, args);
    }, delay);
  };
}

// 滚动到顶部功能
export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// 检查是否应该显示返回顶部按钮
export function shouldShowBackToTop() {
  return window.scrollY > 300;
}

// 初始化Swiper轮播
export function initSwiper() {
  // Swiper通过全局script标签加载，在window对象上可用
  if (typeof window !== 'undefined' && window.Swiper) {
    const swiper = new window.Swiper('.swiper-container', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 17000,
      },
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });

    swiper.on('slideChangeTransitionEnd', function () {
      try {
        const allVideo = document.querySelectorAll("#homeVideo");
        for (let idx in allVideo) {
          const dom = allVideo[idx];
          if (dom && typeof dom.play === 'function') {
            dom.currentTime = 0;
            dom.play();
          }
        }
      } catch (e) {
        console.warn('Video play error:', e);
      }
    });

    return swiper;
  }
  return null;
}

// 初始化视频自动播放
export function initVideoAutoplay() {
  const homeVideo = document.getElementById('homeVideo');
  if (homeVideo) {
    // 延迟5秒后开始播放
    setTimeout(() => {
      try {
        homeVideo.play();
      } catch (e) {
        console.warn('Video autoplay failed:', e);
      }
    }, 5000);

    // 视频结束后重新播放
    homeVideo.addEventListener('ended', function() {
      homeVideo.currentTime = 0;
      try {
        homeVideo.play();
      } catch (e) {
        console.warn('Video replay failed:', e);
      }
    });
  }
}

// 产品模型切换功能
export function initProductModelSwitch() {
  const productModels = document.querySelectorAll('.product-model');
  const productsImg = document.getElementById('productsImg');
  
  if (productModels.length > 0 && productsImg) {
    productModels.forEach(model => {
      // 添加点击事件
      model.addEventListener('click', function() {
        // 移除所有活动状态
        productModels.forEach(m => m.classList.remove('product-active'));
        // 添加当前活动状态
        this.classList.add('product-active');
        
        // 更新图片
        const imgPath = this.getAttribute('data-src');
        if (imgPath) {
          productsImg.innerHTML = `<img class="products-item" src="${imgPath}"/>`;
        }
      });
      
      // 添加点装饰
      if (!model.querySelector('.dot')) {
        const dot = document.createElement('span');
        dot.className = 'dot';
        model.appendChild(dot);
      }
    });
  }
}

// 预加载图片
export function preloadImages() {
  const preloadedImages = {};
  const productModels = document.querySelectorAll('.product-model');
  
  productModels.forEach(model => {
    const imageSrc = model.getAttribute('data-src');
    if (imageSrc && !preloadedImages[imageSrc]) {
      const img = new Image();
      img.onload = function() {
        console.log('Preloaded:', imageSrc);
      };
      img.src = imageSrc;
      preloadedImages[imageSrc] = true;
    }
  });
}

// 初始化所有功能
export function initMainFeatures() {
  // 加载图片
  loadImg();
  
  // 初始化懒加载
  window.addEventListener('scroll', throttle(lazyload, 200));
  
  // 初始化视频自动播放
  initVideoAutoplay();
  
  // 初始化产品模型切换
  initProductModelSwitch();
  
  // 预加载图片
  preloadImages();
  
  // 隐藏滚动鼠标提示（20秒后）
  setTimeout(() => {
    const scrollMouse = document.querySelector('.scroll-mouse');
    if (scrollMouse) {
      scrollMouse.style.display = 'none';
    }
  }, 20000);
}

// Vue组合式API的hook
export function useMainFeatures() {
  const { onMounted, onUnmounted } = require('vue');
  
  let scrollHandler;
  
  onMounted(() => {
    initMainFeatures();
    
    // 设置滚动处理器
    scrollHandler = throttle(lazyload, 200);
    window.addEventListener('scroll', scrollHandler);
  });
  
  onUnmounted(() => {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
    }
  });
  
  return {
    scrollToTop,
    shouldShowBackToTop,
    loadImg,
    lazyload
  };
}